<template lang="pug">
  div
    p.title(v-if="resumen.length") {{ translations.resume }}
    v-simple-table(v-if="resumen.length")
      template(v-slot:default)
        thead
          tr
            th(v-for="(head,i) in headers" :key="'head'+i") {{ head }}
        tbody
          tr(v-for="(field,j) in resumen" :key="'field'+j")
            td.py-2 {{ field.type }}
            td.py-2 {{ field.label }}
            td.py-2 {{ field.name }}
            td.py-2
              template(v-if="field.validators") {{ field.validators }}
              template(v-else) -
            td.py-2
              template(v-if="field.items") {{ field.items }}
              template(v-else) -
            td.py-2.text-right
              v-btn(@click="removeField(j)" icon rounded)
                v-icon mdi-close
    p.title.mt-4 {{ translations.newfield }}
    v-row
      v-col.py-0(cols="12" sm="6" md="4")
        v-select(v-model="field.type" :items="fieldOptions" label="type" outlined dense)
      v-col.py-0(v-if="field.type != null" cols="12" sm="6" md="4")
        v-text-field(v-model="field.label" outlined dense hide-details)
          template(v-slot:label)
            v-icon.pr-1(color="red accent-2" size="12") mdi-asterisk
            | label
      v-col.py-0(v-if="field.type != null" cols="12" sm="6" md="4")
        v-text-field(v-model="field.name" outlined dense hide-details)
          template(v-slot:label)
            v-icon.pr-1(color="red accent-2" size="12") mdi-asterisk
            | name
    v-row(v-if="field.type != null")
      v-col.py-0(cols="12")
        fieldset.fantasy__fieldset--basic
          legend Validators
          v-row
            v-col.py-0(cols="12" sm="6" md="4")
              v-checkbox(v-model="field.validators.required" label="required")
            v-col.py-0(v-if="field.type === 'number'" cols="12" sm="6" md="4")
              .d-flex.align-center
                v-checkbox(v-model="field.validators.min_valueC" label="min_value")
                v-text-field.ml-4(v-if="field.validators.min_valueC" v-model="field.validators.min_valueN" single-line outlined dense hide-details type="number")
            v-col.py-0(v-if="field.type === 'number'" cols="12" sm="6" md="4")
              .d-flex.align-center
                v-checkbox(v-model="field.validators.max_valueC" label="max_value")
                v-text-field.ml-4(v-if="field.validators.max_valueC" v-model="field.validators.max_valueN" single-line outlined dense hide-details type="number")
            v-col.py-0(v-if="field.type === 'string'" cols="12" sm="6" md="4")
              v-checkbox(v-model="field.validators.host" label="host")
            v-col.py-0(v-if="field.type === 'string'" cols="12" sm="6" md="4")
              v-checkbox(v-model="field.validators.email" label="email")
    v-row.mt-4(v-if="field.type != null && field.type === 'select'")
      v-col.py-0(cols="12")
        fieldset.fantasy__fieldset--basic
          legend Items
          v-row
            v-col.py-0(cols="12")
              v-simple-table(v-if="field.items.length")
                template(v-slot:default)
                  thead
                    tr
                      th text
                      th value
                      th
                  tbody
                    tr(v-for="(item,j) in field.items" :key="'field'+j")
                      td.py-2 {{ item.text }}
                      td.py-2 {{ item.value }}
                      td.py-2.text-right
                        v-btn(@click="removeItem(j)" icon rounded)
                          v-icon mdi-close
          v-row
            v-col.py-0(cols="12")
              .d-flex
                v-text-field(v-model="item.text" label="text" outlined dense hide-details)
                v-text-field(v-model="item.value" label="value" outlined dense hide-details)
                v-btn(@click="addItem" icon rounded)
                  v-icon mdi-plus
    v-row.mt-4(v-if="field.type != null && field.label !== null && field.name !== null")
      v-col.py-0(cols="12")
        v-btn(@click="addField" color="green lighten-2") {{ translations.add }}
</template>

<script>
  export default {
    name: "BaseFieldsGenerator",
    model: {
      prop: 'value',
      event: 'input'
    },
    props: {
      value: {
        type: Array,
        default: function(){
          return []
        }
      },
    },
    data:() => ({
      headers: ['type', 'label', 'name', 'validators', 'items', ''],
      fieldOptions: ['string', 'number', 'date', 'select'],
      resumen: [],
      field: {
        type: null,
        label: null,
        name: null,
        validators: {
          required: false,
          min_valueC: false,
          min_valueN: 0,
          max_valueC: false,
          max_valueN: 0,
          host: false,
          email: false,
        },
        items: [],
      },
      item: {
        text: null,
        value: null,
      },
    }),
    computed: {
      translations(){
        return this.$t("components.baseFieldsGenerator");
      }
    },
    watch: {
      value: function(){
        this.resumen = [...this.value];
      }
    },
    created(){
      this.resumen = [...this.value];
    },
    methods:{
      addField(){
        let newField = {
          type: this.field.type,
          label: this.field.label,
          name: this.field.name,
        };
        if (this.field.validators.required) {
          newField['validators'] = {
            required: true
          };
        }
        if (this.field.validators.min_valueC) {
          if(newField.validators === undefined) {
            newField['validators'] = {};
          }
          newField.validators['min_value'] = this.field.validators.min_valueN;
        }
        if (this.field.validators.max_valueC) {
          if(newField.validators === undefined) {
            newField['validators'] = {};
          }
          newField.validators['max_value'] = this.field.validators.max_valueN;
        }
        if (this.field.validators.host) {
          if(newField.validators === undefined) {
            newField['validators'] = {};
          }
          newField.validators['host'] = this.field.validators.host;
        }
        if (this.field.validators.email) {
          if(newField.validators === undefined) {
            newField['validators'] = {};
          }
          newField.validators['email'] = this.field.validators.email;
        }
        if (this.field.type === 'select' && this.field.items.length) {
          newField['items'] = this.field.items;
        }
        this.resumen.push(newField);
        this.$emit('input', this.resumen);
        this.clearFields();
      },
      removeField(index){
        this.resumen.splice(index, 1);
        this.$emit('input', this.resumen);
      },
      addItem(){
        this.field.items.push({
          text: this.item.text,
          value: this.item.value,
        });
        this.item.text = null;
        this.item.value = null;
      },
      removeItem(index){
        this.field.items.splice(index, 1);
      },
      clearFields(){
        this.field.type = null;
        this.field.label = null;
        this.field.name = null;
        this.field.validators.required = false;
        this.field.validators.min_valueC = false;
        this.field.validators.min_valueN = 0;
        this.field.validators.max_valueC = false;
        this.field.validators.max_valueN = 0;
        this.field.validators.host = false;
        this.field.validators.email = false;
        this.field.items = [];
      },
    },
  }
</script>

<style lang="sass">
</style>